import * as React from "react";
import Component from "../../../AbstractComponent";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

export class NewCoachHeader extends Component {

  constructor(public props) {
    super(props);
  }

  public render() {
    const { activeStep, steps, onClose, disabled } = this.props;
    return (
        <div style={{position: "relative", alignItems: "center", borderBottom: "1px solid rgba(0, 0, 0, 0.1)", marginBottom: "30px", minHeight: "90px", overflow: "hidden"}}>
            <Stepper activeStep={activeStep} className="step-header">
                {steps.map((label) => {
                const props = {};
                const labelProps = {};
                return (
                    <Step key={label} {...props}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                );
                })}
            </Stepper>
            <div style={{position: "absolute", top: "28px", right: "30px"}}>
                <div
                    className="icon icon-ic-close close-button"
                    onClick={!disabled && onClose}
                />
            </div>
        </div>
    );
  }
}
